module.exports = __webpack_public_path__ + "img/frame (201).c61b0d1f.jpg";